import { FunctionComponent } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { useTranslation } from '@/lib';
import { CreateTransactionModalFormInput, CreateTransactionModalFormModel } from '../CreateTransactionModal/CreateTransactionModalFormModel';
import { useTransactionContext } from '../../context/TransactionContext';
import { GenericSelect } from '@/components/inputs/GenericSelect';

interface TransactionToLocationFieldProps {
  control: Control<CreateTransactionModalFormInput, unknown, CreateTransactionModalFormModel>;
  errors: FieldErrors<CreateTransactionModalFormInput>;
  disabled?: boolean;
}

export const TransactionToLocationField: FunctionComponent<TransactionToLocationFieldProps> = ({ control, errors, disabled }) => {
  const { t } = useTranslation();
  const { getAvailableLocationsFor } = useTransactionContext();
  const availableLocations = getAvailableLocationsFor('to');

  return (
    <Controller
      name="toLocationId"
      control={control}
      rules={{ required: true }}
      render={({ field }) => (
        <GenericSelect
          label={t('to_location')}
          value={field.value}
          options={availableLocations}
          onChange={(value) => field.onChange(value)}
          error={errors.toLocationId !== undefined}
          helperText={errors.toLocationId?.message}
          disabled={disabled}
        />
      )}
    />
  );
};
